const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesIdeasIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.1863 12.6867C26.1912 11.0189 25.7865 9.37545 25.0078 7.90062C24.2291 6.42579 23.1002 5.16471 21.7202 4.22813C20.3402 3.29155 18.7514 2.70813 17.0932 2.52909C15.4351 2.35004 13.7583 2.58087 12.2102 3.20128C10.6621 3.8217 9.29004 4.81273 8.21446 6.08734C7.13888 7.36195 6.3927 8.88116 6.04146 10.5115C5.69022 12.1419 5.74466 13.8336 6.19999 15.438C6.65533 17.0425 7.49764 18.5106 8.65294 19.7134C10.1051 21.2528 10.9116 23.2905 10.9063 25.4067H21.0929C21.0728 23.3046 21.8713 21.2771 23.3196 19.7534C25.1601 17.8617 26.1888 15.3259 26.1863 12.6867Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 11.4065L13.4531 15.2198H15.9998V11.4065Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.78L18.5467 13.9534H16V17.78Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9067 25.4065H21.0934V27.9532C21.0934 28.6286 20.8251 29.2763 20.3475 29.7539C19.8699 30.2315 19.2222 30.4998 18.5467 30.4998H13.4534C12.778 30.4998 12.1302 30.2315 11.6526 29.7539C11.175 29.2763 10.9067 28.6286 10.9067 27.9532V25.4065Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.733398 12.6863H3.26673",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54688 2.5H7.09354",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54688 22.8599H7.09354",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2667 12.6863H28.7334",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4534 22.8599H24.9067",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4534 2.5H24.9067",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIdeasIcon);
export default __webpack_public_path__ + "static/media/services-ideas-icon.3942fb5918131d3c47da2f96643f1854.svg";
export { ForwardRef as ReactComponent };